<template>
    <div
        class="drag-and-drop"
        @click="inputFiles"
        @drop.prevent="addFiles($event.dataTransfer.files)"
        @drag.prevent
        @dragstart.prevent
        @dragend.prevent
        @dragover.prevent
        @dragenter.prevent
        @dragleave.prevent
    >
        <input
            ref="fileInput"
            type="file"
            multiple
            class="d-none"
            @change="addFiles($event.target.files)"
        >

        <div
            v-if="files.length === 0"
            class="default-text"
        >
            <i class="fas fa-cloud-upload-alt fa-2x" /><br>Ajouter un fichier...
        </div>

        <a
            v-for="(file, key) in files"
            v-else
            :key="key"
            :href="'/storage/' + file.chemin.replace('public/', '')"
            target="_blank"
            class="file-listing rounded"
            @click.stop
        >
            <div class="d-table w-100 h-100">
                <div
                    v-if="file.src"
                    class="d-table-cell img-preview"
                >
                    <img
                        class="preview rounded"
                        :src="file.src"
                    >
                </div>

                <div
                    v-else
                    class="d-table-cell align-middle bg-primary text-white text-center rounded"
                >
                    <i class="fa fa-file fa-6x" />
                </div>
            </div>

            <div class="infos rounded text-center">
                <div
                    class="text-nowrap h-50 filename"
                    :title="file.nom"
                >{{ file.nom }}</div>
                <button
                    class="btn btn-danger btn-sm mt-2"
                    @click.prevent="removeFile(key)"
                >Supprimer</button>
            </div>

            <div class="check">
                <div class="d-table text-center h-100 w-100">
                    <div class="d-table-cell align-middle">
                        <i
                            v-if="file.saved !== undefined && file.saved"
                            key="success"
                            class="fas fa-check-circle fa-3x text-success"
                        />
                        <i
                            v-else-if="file.saved !== undefined && !file.saved"
                            key="error"
                            class="fas fa-times-circle fa-3x text-danger"
                        />
                        <i
                            v-else
                            key="loading"
                            class="fa fa-circle-notch fa-spin fa-3x"
                        />
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        name: "BaseDragAndDropUpload",

        props: {
            url: {type: String, default: null},
            value: {type: Array, default: null},
        },

        data: function () {
            return {
                files: _.cloneDeep(this.value)
            }
        },

        methods: {
            /**
             * Génère les previews des images
             */
            getImagePreview: function (file) {
                if ( /\.(jpe?g|png|gif)$/i.test( file.nom ) ) {
                    let reader = new FileReader()

                    reader.addEventListener("load", () => this.$set(file, 'src', reader.result))

                    reader.readAsDataURL( file.jsFile )
                }
            },

            /**
             * Ajoute un fichier
             */
            addFile: function (jsFile) {
                let file = {nom: jsFile.name, jsFile: jsFile}

                this.files.push(file)

                this.getImagePreview(file, jsFile)

                if (this.url) {
                    this.persistFile(file).then(this.updateValue)
                } else {
                    this.updateValue()
                }
            },

            /**
             * Emet l'evenement de modification des fichiers
             */
            updateValue: function () {
                let files = this.files.filter(file => this.url === undefined || file.saved === true).map(file => {
                    return {
                        nom: file.nom,
                        chemin: file.chemin
                    }
                })

                this.$emit('input', files)
            },

            /**
             * Persiste un fichier à l'url fournit
             */
            persistFile: function (file) {
                let formData = new FormData()

                formData.append('file', file.jsFile)

                let headers = {'Content-Type': 'multipart/form-data'}

                return axios.post(this.url, formData, {headers})
                    .then(response => {
                        this.$set(file, 'chemin', response.data.path)
                        this.$set(file, 'saved', true)
                    })
                    .catch(() => {
                        this.$notify('danger', "le fichier est trop gros ou son type n'est pas accepté.")
                        this.$set(file, 'saved', false)
                    })
            },

            /**
             * Ajoute plusieurs fichiers
             */
            addFiles: function (jsFiles) {
                for( let jsFile of jsFiles) {
                    this.addFile(jsFile)
                }
            },

            /**
             * Supprime un fichier à partir de sa clé
             */
            removeFile: function (key) {
                this.files.splice(key, 1)
                this.updateValue()
            },

            /**
             * Trigger un click sur le file input
             */
            inputFiles: function () {
                this.$refs.fileInput.click()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~sass/_variables";

    .drag-and-drop{
        display: block;
        min-height: 150px;
        width: 100%;
        cursor: pointer;
        border: 2px dashed #E5E5E5;
        border-radius: 10px;
        transition: all .5s;
        padding: 20px;

        &:hover {
            background-color: #F6F6F6;
        }

        .default-text {
            color: #777;
            margin: 2em 0;
            text-align: center;
        }

        .default-text i {
            color: #ccc;
        }

        .file-listing{
            width: 110px;
            height: 110px;
            display: inline-block;
            position: relative;
            margin-right: 20px;
            border-radius: 4px;

            .preview{
                object-fit: cover;
                width: 100%;
                height: 100%;
            }

            .img-preview {
                width: 110px;
                height: 110px;
            }

            &:hover {
                .infos {
                    display: block;
                }

                .check {
                    display: none;
                }
            }

            .infos {
                position: absolute;
                display: none;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: #5578ebcc;
                color: $white;
                padding: 10px;

                .filename {
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }

            .check {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                color: $gray-text;
            }
        }
    }
</style>
